const replaceTagsByWhitespace = (text: string) =>
  text.replace(/<br\s*\/?>/gi, '\n').replace(/<\/?[^>]+(>|$)/g, ' ')

export { replaceTagsByWhitespace }
